import Vue from 'vue';
import axios from 'axios';
import i18n from './lang';

import bugsnagClient from '@lib-shared/bugsnag';
import { getGlobalHandle } from '@lib-shared/helpers';

getGlobalHandle().localSettings['translate'] = {
  instant: (string: string) => {
    const translation = i18n.tc(string);
    return translation.replace(/\[\[/g, '{{').replace(/\]\]/g, '}}');
  },
};

// override $t because of [[ ]] -> {{ }} replacement
Vue.prototype.$t = function (path: string, args) {
  const translation = i18n.t(path, args).toString();
  return translation.replace(/\[\[/g, '{{').replace(/\]\]/g, '}}');
};

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (bugsnagClient) {
      bugsnagClient.notify(error, event => {
        event.groupingHash = error.toString();
      });
    }
    return Promise.reject(error);
  }
);
